// Custom
export const feature = 1
export const focus = 0.8
export const common = 0.6
export const trivial = 0.4
export const subtle = 0.2
export const clear = 0
